import { render, staticRenderFns } from "./PvDrawerArticleRelativeCard.vue?vue&type=template&id=1482fe34&"
import script from "./PvDrawerArticleRelativeCard.vue?vue&type=script&lang=js&"
export * from "./PvDrawerArticleRelativeCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports